export function compareSemanticVersions(a: string, b: string): -1 | 0 | 1 {
  const splitA = a.split(".").map(Number);
  const splitB = b.split(".").map(Number);

  // Ensure both version arrays have at least 3 components, filling with 0s if necessary
  while (splitA.length < 3) splitA.push(0);
  while (splitB.length < 3) splitB.push(0);

  for (let i = 0; i < 3; i++) {
    if (splitA[i] > splitB[i]) return -1; // Version A is newer
    if (splitA[i] < splitB[i]) return 1; // Version B is newer
  }

  return 0; // Versions are equal
}
